// extracted by mini-css-extract-plugin
module.exports = {"header":"hrx_header__1GSPO","header_logo":"hrx_header_logo__qcj8p","header_dlogo":"hrx_header_dlogo__UEvNY","form":"hrx_form__SF7GC"};